var _rect, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRefresh2 = function SvgRefresh2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0454545 0.0526316)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 22,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAATCAYAAACUef2IAAAA+UlEQVQ4EWP4TyPAQCNz/48aDA9ZooLixqM//8vn/vgvG/sNjLXSv4H5n77+gxuEziBo8Pojv+AGwgyG0SALQJZiA3gNBmmCGVI258f/p2/+gs3Ye+73/4j273DXY3M5XoPTJ0I0tyz7gc1RcMMX7vqFIY/XYJhrsbkIZBLI5SA1INejA6wGg1wQ2QFxLUgjiA0yBB2cvgkJKqINBrnQohCSAnC5CGQJyQaDNMEiTjPt239cQQGLwMkbfqJ7Bn+WBgUJtuQEEoMFFS6LsYYxhvVQAVA4g9IuLFJBhmKzGKScJINBPgAZCjIQOV1jcwhJBmMzAJfY0DMYAF8JLrqguAT0AAAAAElFTkSuQmCC"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh2.5e29dc32.svg";
export { ForwardRef as ReactComponent };